'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";
import classnames from "classnames";

import {FaBell, FaRegBell, FaSpinner} from "react-icons/fa";

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {isFalse} from "@uw-it-sis/lib-react/lib/Utils";
import {normalize} from "@uw-it-sis/lib-react/lib/Utils";

import NotifySubscriptionForm from './NotifySubscriptionForm';
import notifyStore from './NotifyStore';
import notifySubscriptionFormStore from './NotifySubscriptionFormStore';

/**
 * The Notify widget on the course details page.
 */
class Notify extends Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.store = notifyStore;
        this.formStore = notifySubscriptionFormStore;

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.resetSubscribeFormActive = this.resetSubscribeFormActive.bind(this);
    }

    close = () => {
        // Clear the Notify Subscription Form Store form data
        this.formStore.clearFormData();
        // Close the modal
        this.store.hideSectionSubscribeForm();
    };

    open = () => this.store.viewSectionSubscribeForm(this.props.section.activityId);

    resetSubscribeFormActive = () => {
        // Clear the Notify Subscription Form Store form data
        this.formStore.clearFormData();
        this.store.hideSectionSubscribeForm();
    };

    render() {
        let sectionName, a11ySectionName;
        if (
            this.props.course.hasOwnProperty("curriculumTitle")
            &&
            this.props.course.curriculumTitle !== null
            &&
            this.props.course.curriculumTitle.trim() !== ""
            &&
            this.props.course.hasOwnProperty("courseNumber")
            &&
            this.props.course.courseNumber !== null
            &&
            this.props.course.courseNumber.trim() !== ""
        ) {
            sectionName = `${this.props.course.curriculumTitle} ${this.props.course.courseNumber} ${this.props.section.code}`;
            a11ySectionName = `${this.props.course.curriculumTitle} ${this.props.course.courseNumber.split('').join(' ')} ${this.props.section.code.split('').join(' ')}`
        } else {
            sectionName = `${normalize(this.props.course.code)} ${this.props.section.code}`;
            a11ySectionName = `${normalize(this.props.course.code)} ${this.props.section.code.split('').join(' ')}`;
        }
        let modalBody, clickHandlerMethod = null;
        let subscribed = false;
        let hoverText = `Subscribing to ${sectionName} is not allowed`;
        let ariaLabel = `Subscribing to ${a11ySectionName} is not allowed`;

        let isPending = this.store.state === States.pending;
        let isCurrentPendingItem = (this.store.state === States.pending && this.formStore.actionPendingItem === this.props.section.activityId);

        // Determine if notify should be disabled
        let disabled = this.props.disabled;
        if ( this.props.section.stateKey.toLowerCase() === "withdrawn" || this.props.section.addCodeRequired || this.props.section.independentStudy ) {
            disabled = true;
        }

        let notifyModal = null;
        // If section notify is disabled, dont create modal or set click action
        if ( isFalse(disabled) ) {
            clickHandlerMethod = isPending ? null : this.open;

            // Does user have endpoints for subscriptions
            if ( this.store.hasEndPoints() ) {
                // Is the user subscribed to this section already
                if ( notifyStore.isSubscribed(this.props.section.activityId) ) {
                    subscribed = true;
                }

                // Set Modal body to be the subscribe form
                modalBody = <NotifySubscriptionForm subscribed={subscribed} {...this.props} />;
            } else {
                // User has no endpoints configured in UW.Notify settings, show message and link to Notify settings
                modalBody =
                    <>
                        <p>To subscribe to seat availability notifications you must first add your email address and/or phone number to your Notify.UW profile.</p>
                        <div className="text-end">
                            <Button variant="primary" href={appStore.getNotifyUrl()}>Add Contact Info</Button>
                        </div>
                    </>;
            }

            hoverText = `${(subscribed ? "Unsubscribe" : "Subscribe")} to ${sectionName} Seat Availability Notifications`;
            ariaLabel = `${(subscribed ? "Unsubscribe" : "Subscribe")} to ${a11ySectionName} Seat Availability Notifications`;

            notifyModal =
                <Modal id={"modal-notify-" + this.props.section.activityId.replace(/:/g, "-")}
                       show={notifyStore.sectionSubscribeFormShown(this.props.section.activityId)}
                       onHide={this.close}
                       onExited={this.resetSubscribeFormActive}
                       className="notifyNotify"
                       aria-labelledby={"modal-notify-" + this.props.section.activityId.replace(/:/g, "-") + "-title"}
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title id={"modal-notify-" + this.props.section.activityId.replace(/:/g, "-") + "-title"} as="h3">{subscribed ? "Update":"Subscribe to"} Seat Availability Notification</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {modalBody}
                    </Modal.Body>
                </Modal>
        }

        let NotifyIcon = isCurrentPendingItem ? FaSpinner : (subscribed ? FaBell : FaRegBell);

        return (
            <>
                <Button variant="icon-link"
                        size={this.props.size ? this.props.size : undefined}
                        className={this.props.className ? this.props.className : ''}
                        title={hoverText}
                        aria-label={ariaLabel}
                        onClick={clickHandlerMethod}
                        disabled={disabled}>
                    <NotifyIcon
                        className={classnames({"icon-spin": isCurrentPendingItem})}
                        aria-hidden={true} />
                </Button>
                {notifyModal}
            </>
        );
    }
}

Notify.propTypes = {
    course: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
    size: PropTypes.string,
    className: PropTypes.string,
    additionalAnalytics: PropTypes.object,
    disabled: PropTypes.bool
};

Notify.defaultProps = {
    size: null,
    disabled: false
};

export default observer(Notify);